__turbopack_context__.v({
  "enterYourEmail": "text-field1-module-scss-module__WIM3pW__enterYourEmail",
  "error": "text-field1-module-scss-module__WIM3pW__error",
  "errorText": "text-field1-module-scss-module__WIM3pW__errorText",
  "label": "text-field1-module-scss-module__WIM3pW__label",
  "row": "text-field1-module-scss-module__WIM3pW__row",
  "textField": "text-field1-module-scss-module__WIM3pW__textField",
});
